import { api } from './api';

const ExerciseServices = {
  createExercise: (params: any, id?: any) => {
    if(id) return api.authPutForm(`auth/owner/exercise/${id}`, params)
    return api.authPostForm('auth/owner/exercise', params)
  },

  deleteExercise: (id?: any) => {
    return api.authDelete(`auth/owner/exercise/${id}`)
  },

  deleteImageExercise: (id?: any) => {
    return api.authPut(`auth/owner/exercise/${id}/delete-image`)
  },

  updateBrik: (id: string, params: any) => {
    return api.authPutForm(`/auth/owner/brik/${id}`, params);
  },

  getDetailExercise: (id: any) => {
    return api.authGet(`/auth/owner/exercise/${id}`);
  },

  getListExercise: (params?: any) => {
    return api.authGet(`/auth/owner/exercise`, params);
  },

  getBrikloListExercise: (params?: any) => {
    return api.authGet(`/auth/owner/exercise/briklo`, params);
  },
};

export default ExerciseServices;
